"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _alert = _interopRequireDefault(require("@meridian/tokens/component/alert"));

var _alertErrorXlarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-error-xlarge"));

var _alertErrorLarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-error-large"));

var _alertErrorSmall = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-error-small"));

var _alertInformationalLarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-informational-large"));

var _alertInformationalSmall = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-informational-small"));

var _alertSuccessXlarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-success-xlarge"));

var _alertSuccessLarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-success-large"));

var _alertSuccessSmall = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-success-small"));

var _alertWarningXlarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-warning-xlarge"));

var _alertWarningLarge = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-warning-large"));

var _alertWarningSmall = _interopRequireDefault(require("@meridian/tokens/base/icon/alert-warning-small"));

var _close = _interopRequireDefault(require("@meridian/tokens/base/icon/close"));

var _theme = require("../theme");

var _button = _interopRequireDefault(require("../button"));

var _token = require("./../utils/token");

var _focus = require("./../utils/focus");

var _getIconCss = _interopRequireDefault(require("./../utils/get-icon-css"));

var _text = _interopRequireDefault(require("./../styles/text"));

var iconTokens = {
  small: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  medium: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  large: {
    error: _alertErrorLarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessLarge["default"],
    warning: _alertWarningLarge["default"]
  },
  xlarge: {
    error: _alertErrorXlarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessXlarge["default"],
    warning: _alertWarningXlarge["default"]
  }
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size,
      type = _ref.type,
      toast = _ref.toast,
      width = _ref.width;
  var borderWidth = t("borderWidth", size);
  var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
  return (0, _emotion.css)({
    /**
     * Container styles
     */
    boxSizing: "border-box",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    alignItems: size === "xlarge" ? "center" : "flex-start",
    backgroundColor: t("backgroundColor", [size, type]),
    borderWidth: borderWidth,
    borderColor: t("borderColor", type),
    borderStyle: borderWidth ? "solid" : undefined,
    borderRadius: t("borderRadius"),
    padding: t("spacingInset", size),
    width: width,
    boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
    "& > * + *": {
      marginLeft: t("spacingHorizontal", size)
    },

    /**
     * Icon styles
     */
    "& > [role=img]": {
      flexShrink: 0,
      alignSelf: size === "xlarge" ? "center" : "stretch",
      backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [size, type])),
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: icon.width,
      // This ensures that the icon is vertically centered on the first line of
      // text for single-line alerts and on the first two lines of text for
      // multi-line alerts.
      minHeight: icon.height,
      maxHeight: icon.height * 2
    },

    /**
     * Title/message wrapper styles
     */
    "& > div": (0, _emotion.css)((0, _text["default"])(t, {
      fontSize: ["message", size],
      fontWeight: "body",
      lineHeight: ["message", size]
    }), {
      textAlign: size === "xlarge" ? "center" : "initial",
      color: t("foregroundColor", [size, type]),
      flex: "auto"
    }),

    /**
     * Title styles
     */
    "& > div > [role=heading]": (0, _emotion.css)((0, _text["default"])(t, {
      fontSize: ["title", size],
      fontWeight: "title",
      lineHeight: ["title", size]
    }), {
      color: t("foregroundColor", [size, type]),
      display: size === "xlarge" ? "block" : "initial",
      flexShrink: 0,
      fontWeight: t("fontWeightTitle"),
      marginRight: t("titleSpacingRight", size),
      marginTop: t("spacingVertical", size)
    }),

    /**
     * Message styles
     */
    "& > div > [mrdn-text]": {
      display: "inline-block",
      margin: "".concat(t("spacingVertical", size), "px 0 0 0")
    }
  });
}, ["size", "type", "toast", "width"]);

var closeButtonStyles = function closeButtonStyles(t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "xlarge" ? {
    position: "absolute",
    top: t("closeButtonSpacing", size),
    right: t("closeButtonSpacing", size)
  } : {
    flexShrink: 0,
    margin: t("closeButtonSpacing", size) - t("spacingInset", size),
    marginLeft: t("spacingHorizontal", size)
  });
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */


function Alert(props) {
  var t = (0, _theme.useTheme)(_alert["default"], "alert");
  var idPrefix = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("alert-");
  }, []);
  var node = (0, _react.useRef)();
  var big = props.size === "large" || props.size === "xlarge";
  var title = big ? props.title : undefined;
  var titleId = title ? "".concat(idPrefix, "-title") : undefined;
  var childrenId = "".concat(idPrefix, "-children");
  var showCloseButton = props.onClose && props.size !== "small"; // If autoFocus is true then focus on the first interactive element in the
  // alert. This'll either be the first action rendered by the user or the
  // alert's close button if there are no actions.

  var autoFocus = props.autoFocus;
  (0, _react.useEffect)(function () {
    if (autoFocus) {
      var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current),
          _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1),
          firstFocusNode = _getKeyboardFocusNode2[0];

      if (firstFocusNode) {
        firstFocusNode.focus();
      }
    }
  }, [autoFocus]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props),
    ref: autoFocus ? node : undefined,
    role: showCloseButton ? "alertdialog" : "alert",
    "aria-labelledby": titleId,
    "aria-describedby": childrenId
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("div", null, title ? /*#__PURE__*/_react["default"].createElement("span", {
    role: "heading",
    id: titleId
  }, title) : null, /*#__PURE__*/_react["default"].createElement("span", {
    "mrdn-text": "",
    id: childrenId
  }, props.children)), showCloseButton ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    size: big ? "medium" : "small",
    iconTokens: _close["default"],
    onClick: props.onClose,
    backdropColor: t("backgroundColor", [props.size, props.type]),
    className: closeButtonStyles(t, props)
  }, props.closeLabel) : null);
}

Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The main message to be shown in the alert. Any elements are allowed, but
   * plain text and links are recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Automatically focus on the alert when it's presented. The first interactive
   * element rendered in the alert will be focused, otherwise the alert's close
   * button will be focused. This will have no effect if the alert does not
   * contain any interactive elements.
   *
   * Use this when presenting an urgent alert that should grab the user's focus.
   * This will disrupt the user's current task, so use this with caution.
   *
   * @since 4.x
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the alert's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset. Note that this also
   * affects the layout of the alert and the availability of other props (namely
   * `title` and `onClose`).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * A text-only title to display before the main message. This is only
   * available for alerts with `size` set to `"large"` or `"xlarge"`.
   */
  title: _propTypes["default"].string,

  /**
   * Use this to indicate that the Alert is being used to display a toast
   * message. A drop shadow will be rendered behind the alert's body. This is
   * only applicable to "medium" and "large" alerts.
   *
   * @since 4.x
   */
  toast: _propTypes["default"].bool,

  /**
   * The type of message that is being communicated with the alert. See the
   * design guidelines for recommendations regarding which type to use.
   */
  type: _propTypes["default"].oneOf(["error", "warning", "success", "informational"]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 4.x
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a function is supplied here then a dismiss button will be rendered in
   * the alert. The function will be called when the dismiss button is clicked.
   * The function will not receive any arguments.
   *
   * This only applies to alerts that are not size small. For alert with `size`
   * set to `"xlarge"` the dismiss button will be placed in the top right of
   * the closest parent element of the alert with non-static positioning.
   */
  onClose: _propTypes["default"].func
} : {};
Alert.defaultProps = {
  size: "large",
  type: "informational",
  closeLabel: "Dismiss"
};
var _default = Alert;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/components/alert/alert.js
// module id = 326
// module chunks = 7